import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'showAction'
})
export class ShowActionPipe implements PipeTransform {
    transform(actions: any[]): any[] {
        return actions.filter((action) => action.show());
    }
}
